import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { server } from "../../Constants";
import { httpClient } from "../../utils/httpclient";
import { RootState } from "../store";
import { ItemData } from "../../types/items.type";


type ItemsData = {
    result: ItemData[];
    message: string;
    isFetching: boolean;
    isError: boolean;
}

const initialStateValues: ItemsData = {
    result: [],
    message: "",
    isFetching: false,
    isError: false,
};


export const itemsGetData = createAsyncThunk(
    "items/getItems",
    async (keyword: string, thunkApi) => {
        try {
            const result = await httpClient.get<ItemData[]>(server.ITEMS_URL + "?keyword=" + keyword);
            return result;
        } catch (error: any) {
            let err = error.response.data.message ?? error.message
            return thunkApi.rejectWithValue(err);
        }
    }
);



const itemsSlice = createSlice({
    name: "items",
    initialState: initialStateValues,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(itemsGetData.pending, (state, action) => {
                state.result = [];
                state.message = "Loading...";
                state.isFetching = true;
                state.isError = false;
            })
            .addCase(itemsGetData.fulfilled, (state, action: PayloadAction<any>) => {
                state.result = action!.payload.data;
                state.message = "Success";
                state.isFetching = false;
                state.isError = false;
            })
            .addCase(itemsGetData.rejected, (state, action: PayloadAction<any>) => {
                state.result = [];
                state.message = action.payload;
                state.isFetching = false;
                state.isError = true;
            });
    }
})


export const { } = itemsSlice.actions;
export const itemsSelector = (store: RootState) => store.itemsReducer;
export default itemsSlice.reducer;